import Reveal from "../components/Reveal";

const STATS = [
  { value: "$45M+", label: "Completed project value" },
  { value: "100%", label: "On-time handover rate" },
  { value: "12-Yr", label: "Workmanship warranty" },
  { value: "142", label: "Awarded remodels" },
];

export default function Stats() {
  return (
    <section data-testid="stats-section" className="border-y border-line bg-surface/40">
      <div className="mx-auto grid max-w-7xl grid-cols-2 lg:grid-cols-4">
        {STATS.map((s, i) => (
          <Reveal
            key={s.label}
            delay={i * 0.06}
            className={`border-line px-6 py-12 text-center sm:px-8 lg:py-16 ${
              i % 2 === 1 ? "border-l" : ""
            } ${i > 1 ? "border-t lg:border-t-0" : ""} ${i > 0 ? "lg:border-l" : ""}`}
          >
            <p data-testid={`stat-value-${i}`} className="font-display text-4xl font-bold tracking-tight text-copper sm:text-5xl">
              {s.value}
            </p>
            <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.25em] text-cream/55">
              {s.label}
            </p>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
